/* eslint-disable quotes */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Form,
  Alert,
} from "reactstrap";
import { login, setError } from "../../../actions/user";
import { getCompanyColors, getCompanyRegParams } from "../../../utils/Api";
import css from "../../../containers/_Full/css";

const applyCSS = () => {
  function replaceAll(string, search, replace) {
    if (replace === undefined) {
      return string.toString();
    }
    return string.split(search).join(replace);
  }

  let companyColors = {
    primary_color: "55, 177, 174",
    secondary_color: "221, 236, 235",
  };
  let companyBg = "";
  const companyColorsPromise = getCompanyColors();
  companyColorsPromise
    .then((newCompanyColors) => {
      localStorage.setItem("colors", JSON.stringify(newCompanyColors.rgb));
      localStorage.setItem("bg", JSON.stringify(newCompanyColors.bg));
    })
    .then(() => {
      const localCompanyColors = localStorage.getItem("colors");
      const localCompanyBg = localStorage.getItem("bg");
      companyColors =
        localCompanyColors === "undefined" || !localCompanyColors
          ? companyColors
          : JSON.parse(localCompanyColors);
      companyBg =
        localCompanyBg === "undefined" || !localCompanyBg
          ? companyBg
          : JSON.parse(localCompanyBg);
    })
    .then(() => {
      let style = document.getElementById("company_colors");
      if (!style) {
        style = document.createElement("style");
        style.setAttribute("id", "company_colors");
      }
      let rCSS = replaceAll(css, "primary_color", companyColors.primary_color);
      rCSS = replaceAll(rCSS, "secondary_color", companyColors.secondary_color);
      rCSS = replaceAll(rCSS, "company_bg", companyBg);
      style.innerHTML = rCSS;
      document.head.appendChild(style);
    });
};

const mapStateToProps = ({ user }) => ({
  token: user.token,
  errorMessage: user.message,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      login,
      setError,
    },
    dispatch
  );

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      password: "",
      allow_registration: true,
    };

    this.submit = this.submit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.resetError = this.resetError.bind(this);
  }

  getRegistrationParams() {
    getCompanyRegParams().then(({ error, ...regParams }) => {
      if (!error) {
        this.setState({ allow_registration: regParams.allow_registration });
      }
    });
  }

  componentDidMount() {
    this.getRegistrationParams();
    this.resetError();
    applyCSS();
  }

  resetError() {
    const { errorMessage } = this.state;
    if (errorMessage) {
      this.setState({ errorMessage: "" });
    }
    if (this.props.errorMessage) {
      this.props.setError("");
    }
  }

  handleChange({ target }) {
    this.setState({ [target.id]: target.value });
    this.resetError();
  }

  submit(ev) {
    ev.preventDefault();

    const { email, password } = this.state;
    const { intl } = this.props;
    if (!email) {
      this.setState({
        errorMessage: intl.formatMessage({ id: "login_fillEmail" }),
      });
    } else if (!password) {
      this.setState({
        errorMessage: intl.formatMessage({ id: "login_fillPassword" }),
      });
    } else {
      this.resetError();
      this.props.login(email, password);
    }
  }

  render() {
    const { email, password, errorMessage } = this.state;
    const { intl, token } = this.props;
    if (token) {
      return <Redirect to="/" />;
    }

    const error = errorMessage || this.props.errorMessage;

    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card className="p-4">
                  <CardBody>
                    <h1>
                      <FormattedMessage id="login_title" />
                    </h1>
                    <p className="text-muted">
                      <FormattedMessage id="login_description" />
                    </p>
                    <Form action="" onSubmit={this.submit}>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-user" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          id="email"
                          placeholder={intl.formatMessage({
                            id: "login_email",
                          })}
                          value={email}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      <InputGroup className="mb-4">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="icon-lock" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="password"
                          id="password"
                          placeholder={intl.formatMessage({
                            id: "login_password",
                          })}
                          value={password}
                          onChange={this.handleChange}
                        />
                      </InputGroup>
                      {error && (
                        <Alert color="danger">
                          <FormattedMessage id={error} />
                        </Alert>
                      )}
                      <Row>
                        <Col xs="12" lg="4">
                          <Button
                            type="submit"
                            color="primary"
                            className="px-4"
                          >
                            <FormattedMessage id="login_title" />
                          </Button>
                        </Col>
                        {this.state.allow_registration && (
                          <Col xs="12" lg="4" className="text-sm-left">
                            <Link type="button" to="/register">
                              <Button color="link" className="px-0">
                                <FormattedMessage id="register_user" />
                              </Button>
                            </Link>
                          </Col>
                        )}
                        <Col xs="12" lg="4" className="text-sm-left">
                          <Link to="/forgot_password">
                            <Button color="link" className="px-0">
                              <FormattedMessage id="login_forgotPassword" />
                            </Button>
                          </Link>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

Login.propTypes = {
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
  token: PropTypes.string,
  errorMessage: PropTypes.string,
  login: PropTypes.func.isRequired,
  setError: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(Login));



// WEBPACK FOOTER //
// ./src/views/Pages/_Login/index.js